import { useState, useRef, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Icon } from '@iconify/react'
import useAuthStore from '../../store/useAuthStore'

const AdminHeader = ({ onMenuClick }) => {
  const { user, logout } = useAuthStore()
  const navigate = useNavigate()
  const [showDropdown, setShowDropdown] = useState(false)
  const dropdownRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const getUserName = () => {
    if (user?.firstName && user?.lastName) {
      return `${user.firstName} ${user.lastName}`
    }
    if (user?.name) {
      return user.name
    }
    return 'Admin User'
  }

  const getInitials = () => {
    if (user?.firstName && user?.lastName) {
      return `${user.firstName[0]}${user.lastName[0]}`.toUpperCase()
    }
    if (user?.name) {
      return user.name
        .split(' ')
        .map((n) => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2)
    }
    return 'SA'
  }

  const handleLogout = async () => {
    await logout()
    navigate('/login')
  }

  return (
    <header className="bg-white px-4 lg:px-6 py-4 flex justify-between lg:justify-end items-center shadow-sm sticky top-0 z-30">
      {/* Menu button - visible on screens smaller than lg */}
      <button
        onClick={onMenuClick}
        className="lg:hidden p-2 text-text-secondary hover:bg-bg-light hover:text-primary rounded-lg transition-all duration-150"
        aria-label="Toggle menu"
      >
        <Icon icon="mdi:menu" className="text-2xl" />
      </button>

      <div className="flex items-center gap-2 lg:gap-4">
        {/* User Profile Dropdown */}
        <div className="relative" ref={dropdownRef}>
          <button
            onClick={() => setShowDropdown(!showDropdown)}
            className="flex items-center gap-2 md:gap-3 p-2 bg-gray-100 hover:bg-gray-200 rounded-lg transition-all duration-150"
          >
            <div className="w-8 h-8 lg:w-10 lg:h-10 rounded-full bg-gradient-to-br from-primary to-primary-dark flex items-center justify-center text-white font-semibold text-xs lg:text-sm flex-shrink-0">
              {getInitials()}
            </div>
            <div className="hidden lg:flex flex-col items-start">
              <span className="text-sm font-semibold text-text-dark">{getUserName()}</span>
              <span className="text-xs text-text-secondary">{user?.email || 'No email'}</span>
            </div>
            <Icon icon="mdi:chevron-down" className="text-text-secondary hidden lg:block" />
          </button>

          {showDropdown && (
            <div className="absolute top-full right-0 mt-2 bg-white rounded-lg shadow-xl border border-border-light min-w-[200px] py-1 animate-fade-in z-50">
              <Link
                to="/admin/profile-setting"
                onClick={() => setShowDropdown(false)}
                className="flex items-center gap-3 px-4 py-3 text-text-dark hover:bg-bg-light transition-colors"
              >
                <Icon icon="mdi:account-cog" className="text-lg" />
                <span>Profile Settings</span>
              </Link>
              <hr className="my-1 border-border-light" />
              <button
                onClick={handleLogout}
                className="w-full flex items-center gap-3 px-4 py-3 text-danger hover:bg-red-50 transition-colors text-left"
              >
                <Icon icon="mdi:logout" className="text-lg" />
                <span>Logout</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  )
}

export default AdminHeader
